import { axios } from '@Root/API'

export const get = (studyProgrammeId, curriculumAccreditationId) => {
	return axios.get(`program/${studyProgrammeId}/curriculum-accreditation/${curriculumAccreditationId}`)
}
